import { Input } from "@/components/podkit/forms/Input";
import { Search } from "lucide-react";
import type { FC } from "react";

type ProjectSearchInputProps = {
    searchValue?: string;
    isLoading?: boolean;
    disabled?: boolean;
    setSearchValue: (value: string) => void;
};
export const ProjectSearchInput: FC<ProjectSearchInputProps> = ({ searchValue, disabled, setSearchValue }) => {
    return (
        <label className="relative flex w-full">
            <span className="sr-only">Search projects</span>

            <Search className="absolute left-[12px] top-[11px] z-10 text-content-tertiary" size={14} />
            <Input
                placeholder="Search projects"
                className="w-full max-w-none pl-8"
                value={searchValue || ""}
                onChange={(e) => setSearchValue(e.target.value.trimStart().replace(/\s+/g, " "))}
                disabled={disabled}
            />
        </label>
    );
};
